import React, { Component, ReactElement } from "react";
import ServiceContainer, { ServiceCard } from "./ServiceContainer";
import { StringUtil } from "@eres/core";


interface Props {
	hideSideBar?: boolean;
	sectionClass?: string;
	containerClass?: string;
	rowClass?: string;
	contentClass?: string;
	header?: ReactElement;
	sidebar?: ReactElement;
	noBreadCrumb?: boolean;
	services?: ServiceCard[];
	serviceTitle: string;
	title?: string;
	titleContainerClass?: string;
	titleExtra?: ReactElement;
	subTitleExtra?: ReactElement;
	hideQLinks?: boolean;
	showServiceSearch?: boolean;
	serviceDescStringPool?: string;
	extraServices?: ServiceCard[];
	extraServiceTitle?: string;
}

interface State {

}

class PageContent extends Component<Props, State> {
	static defaultProps: Partial<Props> = {
		hideSideBar: false,
		sectionClass: "property-details container-wrapper",
		containerClass: "container",
		rowClass: "row",
		contentClass: "col-md-12",
		noBreadCrumb: false,
		titleContainerClass: "col-md-12",
	};

	render() {
		const {
			services, serviceTitle, title, titleContainerClass, titleExtra,
			hideQLinks, showServiceSearch, serviceDescStringPool, subTitleExtra, extraServices, extraServiceTitle
		} = this.props;
		return (
			<section className={ this.props.sectionClass }>
				<div className={ this.props.containerClass }>
					<div className={ this.props.rowClass }>
						{ !StringUtil.isEmptyStringOrNull( title ) &&
							<div className={ titleContainerClass }>
								<div className="page-title">
									<div className="page-sub-title-extra">
										{ title }
										{ subTitleExtra }
									</div>
									<div>
										{ titleExtra }
									</div>
								</div>
							</div>
						}
						{ this.props.header }
						<div className={ this.props.contentClass }>
							{ this.props.children }
						</div>
						{ this.props.sidebar }
						{ this.props.sidebar == null &&
							<ServiceContainer
								showSearch={ showServiceSearch }
								hideQLinks={ hideQLinks ?? true }
								descStringPool={ serviceDescStringPool }
								title={ serviceTitle } services={ services }/> }
						{ this.props.sidebar == null && this.props.extraServices &&
							<ServiceContainer
								showSearch={ showServiceSearch }
								hideQLinks={ hideQLinks }
								descStringPool={ serviceDescStringPool }
								title={ extraServiceTitle } services={ extraServices }/> }
					</div>
				</div>
			</section>
		);
	}
}

export default PageContent;
